import { useEffect, useRef, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import type { OneJogConfig } from './types';
import { initFirebase, getDb } from './services/firebase';
import { loadGA } from './services/analytics';
import { observeDataLayer, tryCaptureThankYouPage } from './services/ecommerceListener';
import { logAIPageViewIfNeeded, registerGlobalLogger } from './services/aiActivityLogger';
import { PopupRecentlySold } from './components/PopupRecentlySold';

interface WidgetProps {
  config: OneJogConfig;
}

export function Widget({ config: initialConfig }: WidgetProps) {
  const initRef = useRef(false);
  const [config, setConfig] = useState<OneJogConfig>(initialConfig);

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    try {
      initFirebase(initialConfig);
    } catch (e) {
      if (typeof console !== 'undefined') console.warn('[Kenbun] Firebase init failed:', e);
    }

    if (initialConfig.gaMeasurementId) {
      loadGA(initialConfig);
    }

    observeDataLayer(initialConfig.siteId, initialConfig);

    tryCaptureThankYouPage(initialConfig.siteId, initialConfig);

    logAIPageViewIfNeeded(initialConfig.siteId);
    registerGlobalLogger();
  }, [initialConfig]);

  // Siempre comprobar en Firestore si la encuesta está habilitada; no mostrar la burbuja hasta saberlo (evita parpadeo)
  useEffect(() => {
    const db = getDb();
    if (!db || !initialConfig.siteId) {
      return;
    }
    getDoc(doc(db, 'sites', initialConfig.siteId))
      .then((snap) => {
        if (snap.exists()) {
          const data = snap.data();
          setConfig((prev) => ({
            ...prev,
            disableRecentlySoldPopup: data?.disableRecentlySoldPopup === true,
          }));
        }
      })
      .catch(() => {});
  }, [initialConfig.siteId]);

  return (
    <>
      {!config.disableRecentlySoldPopup && (
        <PopupRecentlySold siteId={config.siteId} maxItems={5} />
      )}
    </>
  );
}
